import { TagsApiEndpoints } from '@contracts';

export const TAGS_ENDPOINTS: TagsApiEndpoints = {
  get: {
    path: 'tags/',
    version: 'v1',
    domain: 'core',
  },
  create: {
    path: 'tags/',
    version: 'v1',
    domain: 'core',
  },
  update: {
    path: 'tags/',
    version: 'v1',
    domain: 'core',
  },
  delete: {
    path: 'tags/',
    version: 'v1',
    domain: 'core',
  },
};
